import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const cultivars = [
  {
    name: "AV Gas",
    route: "/cultivars/av-gas",
    image: "/images/av-gas.png",
    description: "A high-octane strain with bold flavors and potent effects.",
  },
  {
    name: "Blackberry Moonrocks",
    route: "/cultivars/blackberry-moonrocks",
    image: "/images/blackberry-moonrocks.png",
    description: "Rich blackberry aroma with a powerful, long-lasting high.",
  },
  {
    name: "Bubba",
    route: "/cultivars/bubba",
    image: "/images/bubba-kush.png",
    description:
      "A classic strain known for its earthy flavor and deep relaxation.",
  },
  {
    name: "Cadillac Rainbows",
    route: "/cultivars/cadillac-rainbows",
    image: "/images/cadillac-rainbows.png",
    description: "Colorful and vibrant with a sweet, fruity aroma.",
  },
  {
    name: "Chemical Bromance",
    route: "/cultivars/chemical-bromance",
    image: "/images/chem-de-la-chem.png",
    description: "Potent and gassy, perfect for those who love strong effects.",
  },
  {
    name: "Donkey Butter",
    route: "/cultivars/donkey-butter",
    image: "/images/donkey-butter.png",
    description: "A pungent and relaxing strain with a creamy, nutty flavor.",
  },

  {
    name: "Fast Orange",
    route: "/cultivars/fast-orange",
    image: "/images/fast-orange.png",
    description: "Citrus-forward strain with an uplifting and energetic high.",
  },
  {
    name: "Fruity Pebbles 2.0",
    route: "/cultivars/fruity-pebbles-2-0",
    image: "/images/fruity-pebbles-2-0.png",
    description: "Sweet and fruity with a rainbow of flavors and colors.",
  },
  {
    name: "Gastro Pop",
    route: "/cultivars/gastro-pop",
    image: "/images/gastro-pop.png",
    description:
      "A fizzy, flavorful strain with a relaxing yet euphoric effect.",
  },
  {
    name: "Georgia",
    route: "/cultivars/georgia",
    image: "/images/georgia.png",
    description: "Smooth and mellow, perfect for unwinding after a long day.",
  },
  {
    name: "Island Pink",
    route: "/cultivars/island-pink",
    image: "/images/pink-kush.png",
    description: "A tropical delight with floral and fruity notes.",
  },
  {
    name: "Jealousy",
    route: "/cultivars/jealousy",
    image: "/images/jealousy.png",
    description:
      "A bold strain with a sweet and sour aroma that leaves a lasting impression.",
  },
  {
    name: "Jelly Breath",
    route: "/cultivars/jelly-breath",
    image: "/images/jelly-breath.png",
    description: "Dense, frosty buds with a sweet berry and vanilla flavor.",
  },
  {
    name: "Mac Donut",
    route: "/cultivars/mac-donut",
    image: "/images/mac-donut.png",
    description:
      "A decadent strain with sweet, doughy flavors and a balanced high.",
  },
  {
    name: "Master Kush Ultra",
    route: "/cultivars/master-kush-ultra",
    image: "/images/mk-ultra.png",
    description: "Deeply relaxing with a pungent earthy aroma.",
  },
  {
    name: "Peanut Butter Rockstar",
    route: "/cultivars/peanut-butter-rockstar",
    image: "/images/peanut-butter-rockstar.png",
    description: "Nutty and sweet with a heavy body high.",
  },
  {
    name: "Permanent Marker",
    route: "/cultivars/permanent-marker",
    image: "/images/permanent-marker.png",
    description: "Pungent and sticky with a unique, lingering aroma.",
  },
  {
    name: "Pine Tar",
    route: "/cultivars/pine-tar",
    image: "/images/pine-tar.png",
    description: "Strong pine scent with a classic earthy taste.",
  },
  {
    name: "Platinum Lemon Cherry Gelato",
    route: "/cultivars/platinum-lemon-cherry-gelato",
    image: "/images/platinum-lemon-cherry-gelato.png",
    description: "A zesty lemon-cherry delight with smooth effects.",
  },
  {
    name: "Rotten Runtz",
    route: "/cultivars/rotten-runtz",
    image: "/images/Runtz.png",
    description: "Sweet yet pungent with a funky, lingering aroma.",
  },
  {
    name: "Rockstar",
    route: "/cultivars/rockstar",
    image: "/images/rockstar.png",
    description: "Potent and relaxing with an earthy, spicy profile.",
  },
  {
    name: "White Runtz",
    route: "/cultivars/white-runtz",
    image: "/images/Runtz_white.png",
    description: "Frosty, candy-like buds with a euphoric high.",
  },
  {
    name: "Sleepy Joe OG",
    route: "/cultivars/sleepy-joe-og",
    image: "/images/sleepy-joe-og.png",
    description: "Perfect for nighttime relaxation and deep sleep.",
  },
  {
    name: "Tom Ford Pink",
    route: "/cultivars/tom-ford-pink",
    image: "/images/Kush.png",
    description: "Luxury strain with a heavy body high and rich flavors.",
  },
  {
    name: "Tropical Cherry Blast",
    route: "/cultivars/tropical-cherry-blast",
    image: "/images/tropical-cherry-blast.png",
    description: "Explosive cherry flavor with an uplifting effect.",
  },
  {
    name: "Zoap",
    route: "/cultivars/zoap",
    image: "/images/zoap.png",
    description: "A complex aroma with creamy, citrusy notes.",
  },
];

const CultivarDisplay = () => {
  const randomCultivars = cultivars.sort(() => 0.5 - Math.random()).slice(0, 4);

  return (
    <div className="bg-gradient-to-b from-gray-900 to-black text-white py-16 px-6">
    <div className="max-w-7xl mx-auto text-center">
      <motion.h2
        className="text-4xl font-extrabold text-green-400 mb-10"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        Explore More Cultivars
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {randomCultivars.map((cultivar, index) => (
          <Link to={cultivar.route} key={index}>
            <motion.div
              className="relative bg-gray-800 bg-opacity-90 p-6 rounded-xl shadow-lg overflow-hidden group cursor-pointer h-full"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05, rotate: [0, 1, -1, 0] }}
              transition={{ duration: 0.3, ease: "easeInOut" }}
            >
              <motion.div
                className="absolute -inset-1 bg-green-500 opacity-0 rounded-xl transition-opacity group-hover:opacity-30 blur-xl"
                animate={{ scale: [1, 1.2, 1] }}
                transition={{
                  repeat: Infinity,
                  duration: 3,
                  ease: "easeInOut",
                }}
              />

              <motion.img
                src={cultivar.image}
                alt={cultivar.name}
                className="w-full h-40 object-contain rounded-lg shadow-md bg-black"
                whileHover={{ scale: 1.1 }}
                transition={{ duration: 0.3 }}
              />

              <div className="mt-6">
                <h3 className="text-2xl font-semibold text-green-400">
                  {cultivar.name}
                </h3>
                <p className="text-gray-300 text-sm mt-2">
                  {cultivar.description}
                </p>
                <span className="mt-4 inline-block text-green-300 font-medium hover:underline transition-all duration-300">
                  Learn More →
                </span>
              </div>
            </motion.div>
          </Link>
        ))}
      </div>
    </div>
  </div>
  );
};

export default CultivarDisplay;
